import type { Attachment } from '../types/gateway';

/** Build a message.send payload */
export function buildMessageSend(content: string, sessionId?: string, attachments?: Attachment[]) {
  return {
    type: 'message.send',
    data: {
      content,
      sessionId,
      attachments,
    },
  };
}

/** Build a session.create payload */
export function buildSessionCreate(name?: string, metadata?: Record<string, unknown>) {
  return {
    type: 'session.create',
    data: { name, metadata },
  };
}

/** Build a session.list request */
export function buildSessionList() {
  return { type: 'session.list' };
}

/** Build a presence.update payload */
export function buildPresenceUpdate(status: 'typing' | 'idle' | 'online', sessionId?: string) {
  return {
    type: 'presence.update',
    data: { status, sessionId },
  };
}

/** Encode a file as a base64 attachment */
export async function fileToAttachment(file: File): Promise<Attachment> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = (reader.result as string).split(',')[1];
      resolve({
        name: file.name,
        type: file.type,
        data: base64,
        size: file.size,
      });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
